function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#002A33;}\n\t.st2{clip-path:url(#SVGID_00000030459203070414804810000008616869261934108312_);}\n\t.st3{fill:#6CB9B2;}\n\t.st4{fill:#E6E9ED;}\n\t.st5{fill:#EF715F;}\n\t.st6{fill:#334B5D;}\n\t.st7{fill:#FFCE65;}\n\t.st8{fill:#ACB3B9;}\n\t.st9{fill:#5CC0E7;}\n\t.st10{fill:#45BBA3;}\n\t.st11{fill:#F5B357;}\n\t.st12{fill:#2D3C4D;}\n\t.st13{opacity:0.5;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 139.9,
  cy: 139.9,
  r: 131.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M139.9,279.7C62.7,279.7,0,217,0,139.9S62.7,0,139.9,0s139.9,62.7,139.9,139.9S217,279.7,139.9,279.7z  M139.9,17C72.1,17,17,72.1,17,139.9s55.1,122.9,122.9,122.9s122.9-55.1,122.9-122.9S207.6,17,139.9,17z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "SVGID_1_",
  cx: 140,
  cy: 139.8,
  rx: 123.1,
  ry: 122.6
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: -22.6,
  y: -9.5,
  className: "st3",
  width: 319.4,
  height: 319.4
});

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 57.9,
  y: 54,
  className: "st0",
  width: 140.8,
  height: 202.1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 69.5,
  y: 180.6,
  className: "st4",
  width: 117.7,
  height: 4.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 69.5,
  y: 190.6,
  className: "st4",
  width: 117.7,
  height: 4.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 69.5,
  y: 200.6,
  className: "st4",
  width: 117.7,
  height: 4.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 69.5,
  y: 210.7,
  className: "st4",
  width: 117.7,
  height: 4.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 69.5,
  y: 220.7,
  className: "st4",
  width: 117.7,
  height: 4.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 69.5,
  y: 230.7,
  className: "st4",
  width: 117.7,
  height: 4.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 69.5,
  y: 240.8,
  className: "st4",
  width: 52.7,
  height: 4.2
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 75.6,
  y: 148,
  className: "st5",
  width: 10.3,
  height: 27
}), /*#__PURE__*/React.createElement("rect", {
  x: 94.6,
  y: 151.2,
  className: "st6",
  width: 10.3,
  height: 23.9
}), /*#__PURE__*/React.createElement("rect", {
  x: 113.6,
  y: 147.4,
  className: "st7",
  width: 10.3,
  height: 27.7
}), /*#__PURE__*/React.createElement("rect", {
  x: 132.7,
  y: 148.8,
  className: "st8",
  width: 10.3,
  height: 26.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 151.7,
  y: 148.3,
  className: "st9",
  width: 10.3,
  height: 26.7
}), /*#__PURE__*/React.createElement("rect", {
  x: 170.7,
  y: 72.4,
  className: "st10",
  width: 10.3,
  height: 102.7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "192.8,218 181.8,229 174.8,217.3 181.1,211  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M219.4,244.6c2.4,2.4-8.6,13.4-11,11c-10.3-7.2-19.4-16.3-26.6-26.6c3.7-3.7,7.3-7.3,11-11 C203.1,225.2,212.2,234.2,219.4,244.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M206.4,254.1c0.7,0.5,1.3,1,2,1.5c2.4,2.4,13.4-8.6,11-11c-0.5-0.7-1-1.4-1.5-2L206.4,254.1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st11",
  points: "177.8,214.2 174.8,217.3 181.8,229 187.2,223.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M187.2,223.6l-5.4,5.4c7.2,10.3,16.3,19.4,26.6,26.6c1.2,1.2,4.4-0.9,7.2-3.6L187.2,223.6L187.2,223.6z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M212,248.4l-5.6,5.6c0.7,0.5,1.3,1,2,1.5c1.2,1.2,4.4-0.9,7.2-3.6L212,248.4L212,248.4z"
}))), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M131.9,168.2c-13.6,13.6-13.6,35.5,0,49.1s35.5,13.6,49.1,0c13.6-13.6,13.6-35.5,0-49.1 C167.5,154.6,145.5,154.6,131.9,168.2L131.9,168.2z M175.7,211.9c-10.6,10.6-27.9,10.6-38.5,0s-10.6-27.8,0-38.5 c10.6-10.6,27.8-10.6,38.5,0C186.3,184.1,186.3,201.3,175.7,211.9z"
}), /*#__PURE__*/React.createElement("g", {
  className: "st13"
}, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 156.5,
  cy: 192.7,
  r: 27.2
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 209.4,
  y: 104.5,
  className: "st7",
  width: 11.6,
  height: 88.3
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M220.9,103.4v11.7h-11.6v-11.7c0-1,0.8-1.7,1.7-1.7h8.1C220.2,101.7,220.9,102.5,220.9,103.4z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "209.4,192.8 209.4,192.8 220.9,192.8 220.9,192.8 215.1,206.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "212.6,200.8 215.1,206.9 217.6,200.8  "
}), /*#__PURE__*/React.createElement("rect", {
  x: 209.4,
  y: 115.1,
  className: "st0",
  width: 11.6,
  height: 3.4
})));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M155.6,74.4h-15.3c-1,0-1.8,0.8-1.8,1.9s0.8,1.9,1.8,1.9h10.8l-45,46.8c0,0.1,0,0.2,0.1,0.3 c0.2,1.4,0.5,2.8,0.8,4.1l46.9-48.7v11.4c0,1.1,0.8,1.9,1.8,1.9s1.8-0.8,1.8-1.9V76.3C157.5,75.2,156.7,74.4,155.6,74.4 L155.6,74.4z"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 78.9,
  y: 125,
  className: "st5",
  width: 28.4,
  height: 4.1
});

function SvgQ6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 279.7 279.7",
    style: {
      enableBackground: "new 0 0 279.7 279.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173872818492598987660000000502037096164071563_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000173872818492598987660000000502037096164071563_)"
    }
  }, _ref5, _ref6, _ref7, _ref8))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ6);
export default __webpack_public_path__ + "static/media/q6.d43c348174e154d29802f52bb4195719.svg";
export { ForwardRef as ReactComponent };